<!--
 * @FilePath: query.vue
 * @Author: chenwei
 * @Date: 2022-09-19 13:47:37
 * @LastEditors: chenwei
 * @LastEditTime: 2022-09-20 18:57:15
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
-->
<template>
  <div class="centerS query-tool">
    <div class="center">
        <span class="c1">周期：</span>
        <el-radio-group 
        class="rara"
        @change="updata1" 
        v-model="form.type">
            <el-radio :label="3">日</el-radio>
            <el-radio :label="6">月</el-radio>
            <el-radio :label="9">年</el-radio>
        </el-radio-group>
        <el-date-picker
            v-if="form.type===3"
            size="mini"
            type="month"
            @change="updata2"
            value-format='yyyy-MM'
            v-model="form.timeM"
            placeholder="选择月">
        </el-date-picker>
        <el-date-picker
            v-if="form.type===6"
            size="mini"
            @change="updata2"
            type="year"
            value-format='yyyy'
            v-model="form.timeY"
            placeholder="选择年">
        </el-date-picker>
    </div>
    <!-- <div class="hint">{{hint}}</div> -->
  </div>
</template>

<script>
export default {
    props:{
        hint:{
            type:String,
            default:'默认统计当年，按月统计'
        }
    },
    data(){
        return {
            form:{
               type:6,
               timeM:new Date() ,
               timeY:new Date() 
            }
        }
    },
    methods:{
        getTime(date) {
            let y = date.getFullYear() //年
            let m = date.getMonth() + 1  //月，月是从0开始的所以+1
            let d = date.getDate() //日
            m = m < 10 ? "0" + m : m //小于10补0
            d = d < 10 ? "0" + d : d //小于10补0
            return y + "-" + m + "-" + d; //返回时间形式yyyy-mm-dd
        },
        updata1(){
            let date = this.getTime(new Date())
            this.form.timeM = date
            switch (this.form.type) {
                case 3:
                    this.form.type=3
                    break;
                case 6:
                    this.form.timeY = date.slice(0,4)
                    this.form.type=6
                    break;
            
                default:
                    this.form.type=9
                    break;
            }
            this.$emit('updata',this.form)
        },
        updata2(){
            this.$emit('updata',this.form)
        }
    }
}
</script>

<style lang="scss" scoped>
.c1{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2F2F2F;
}
.rara{
    margin-right: 12px;
    margin-top: 4px;
}
.query-tool{
    height: 48px;
}
.hint{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FE9436;
}
</style>